module.exports = __webpack_public_path__ + "static/twitter-3f2795c3177c22b21e072678ed5f20c5.png";